import { convertGuestProfile } from "../api/client";
import { isValidProfile, loadProfile } from "./storage";

export function buildGuestConversionPayload(conversionState = {}) {
  const guestProfile = conversionState.guestProfile || conversionState.profile || loadProfile();
  const results = Array.isArray(conversionState.results)
    ? conversionState.results
    : [];

  if (!isValidProfile(guestProfile)) {
    return null;
  }

  return {
    guest_id: guestProfile.guest_id,
    profile: guestProfile,
    results: results.map((result) => ({
      show_id: result.show_id ?? result.id ?? null,
      title: result.title ?? null,
    })),
  };
}

export async function convertGuestSession(conversionState = {}) {
  const payload = buildGuestConversionPayload(conversionState);

  if (!payload) {
    return false;
  }

  await convertGuestProfile(payload);
  return true;
}
